import React from "react";
import {Warning} from "../../wui-core/src";
import SearchTabs from './SearchTabs';
import Tab from './Tab'
import {Tabs as TabsInner} from './Tabs';
import { EntranceProps } from './iTabs'
import { WithConfigConsumer } from "../../wui-provider/src/context";

const {isShouldUpdate} = Warning;

interface TabsComponent extends React.FC<EntranceProps> {
    SearchTabs: typeof SearchTabs & { Item: typeof Tab };
    TabPane: typeof TabsInner.TabPane;
}

const Tabs: TabsComponent = (props) => {
    const { extraContent, tabBarExtraContent, tabPosition, tabBarPosition, tabBarStyle, type, style } = props;

    const tabBarStyleTypeMap = {
        line: 'simple',
        card: 'upborder',
        'editable-card': 'editable-card',
        'simple': 'simple',
        'fill': 'fill',
        'primary': 'primary',
        'trangle': 'trangle',
        'upborder': 'upborder',
        'fade': 'fade',
        'downborder': 'downborder',
        'trapezoid': 'trapezoid',
        'fill-line': 'fill-line'
    };

    isShouldUpdate("Tabs", props);

    const disableProps = {
        animated: false,
        scrollAnimated: false, // scrollableBar的class
        inkBarAnimated: false, // inkBar的class
        tabBarPosition: tabPosition ? tabPosition : tabBarPosition,
        extraContent: tabBarExtraContent ? tabBarExtraContent : extraContent,
        style: style,
        tabBarStyle: (typeof tabBarStyle === 'object') ? tabBarStyle : null,
        type: tabBarStyleTypeMap[(type ? type : (typeof tabBarStyle === 'string') ? tabBarStyle : 'line') as keyof typeof tabBarStyleTypeMap]
    };

    return (<TabsInner {...props} {...disableProps}/>);
};

// 添加静态属性
Tabs.SearchTabs = SearchTabs;
Tabs.TabPane = TabsInner.TabPane;
Tabs.SearchTabs.Item = Tab;

// 应用装饰器
const TabsWithConsumer = WithConfigConsumer({name: "tabs"})(Tabs);

export default TabsWithConsumer;
